/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ReorderOrderV2Fragment = {
  readonly __typename: 'Order';
  readonly id: string;
  readonly wantedTime: string;
  readonly deliveryOrderDetail: {
    readonly __typename: 'DeliveryOrderDetail';
    readonly id: string;
    readonly deliveryFee: number;
    readonly tip: number;
    readonly vendor: string;
    readonly vendorRestaurantId: string;
    readonly address: {
      readonly __typename: 'Address';
      readonly id: string;
      readonly name: string | null;
    } | null;
  } | null;
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
  };
  readonly lineItems: ReadonlyArray<{
    readonly __typename: 'LineItem';
    readonly id: string;
    readonly customName: string | null;
    readonly isCustom: boolean;
    readonly canReorderAtRestaurant: boolean;
    readonly dressingMode: Types.DressingMode;
    readonly mixedDressingDetails: ReadonlyArray<{
      readonly __typename?: 'MixedDressingDetails';
      readonly weight: Types.DressingWeight;
      readonly ingredientId: string;
    }>;
    readonly removedIngredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
    }>;
    readonly addedIngredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
    }>;
    readonly product: {
      readonly __typename: 'Product';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly isCustom: boolean;
      readonly enableDressingDetails: boolean;
      readonly categoryName: string;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly ingredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
      }>;
    };
  }>;
};

export type OrdersV2ForReorderV2QueryVariables = Types.Exact<{
  input: Types.OrdersInputV2;
  restaurantId: Types.Scalars['Int']['input'];
}>;

export type OrdersV2ForReorderV2Query = {
  readonly __typename?: 'Query';
  readonly ordersV2:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly pagination: {
          readonly __typename?: 'Pagination';
          readonly total: number;
          readonly last: number;
        };
        readonly orders: ReadonlyArray<{
          readonly __typename: 'Order';
          readonly id: string;
          readonly wantedTime: string;
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly deliveryFee: number;
            readonly tip: number;
            readonly vendor: string;
            readonly vendorRestaurantId: string;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly name: string | null;
            } | null;
          } | null;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly customName: string | null;
            readonly isCustom: boolean;
            readonly canReorderAtRestaurant: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly weight: Types.DressingWeight;
              readonly ingredientId: string;
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
            }>;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly slug: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly enableDressingDetails: boolean;
              readonly categoryName: string;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
          }>;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const ReorderOrderV2FragmentDoc = gql`
  fragment ReorderOrderV2 on Order {
    id
    __typename
    wantedTime
    deliveryOrderDetail {
      id
      __typename
      address {
        id
        __typename
        name
      }
      deliveryFee
      tip
      vendor
      vendorRestaurantId
    }
    restaurant {
      id
      __typename
      slug
    }
    lineItems {
      id
      __typename
      customName
      isCustom
      canReorderAtRestaurant(restaurantId: $restaurantId)
      mixedDressingDetails {
        weight
        ingredientId
      }
      removedIngredients {
        id
        __typename
        name
        kind
      }
      addedIngredients {
        id
        __typename
        name
        kind
      }
      dressingMode
      product {
        id
        __typename
        slug
        name
        isCustom
        enableDressingDetails
        categoryName
        asset {
          url
        }
        ingredients {
          id
          __typename
          name
          kind
        }
      }
    }
    restaurant {
      id
      __typename
      name
    }
  }
`;
export const OrdersV2ForReorderV2Document = gql`
  query ordersV2ForReorderV2($input: OrdersInputV2!, $restaurantId: Int!) {
    ordersV2(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        pagination {
          total
          last
        }
        orders {
          ...ReorderOrderV2
        }
      }
      ... on ValidationError {
        fieldErrors {
          field
          message
        }
      }
    }
  }
  ${ReorderOrderV2FragmentDoc}
`;

export function useOrdersV2ForReorderV2Query(
  options: Omit<Urql.UseQueryArgs<OrdersV2ForReorderV2QueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrdersV2ForReorderV2Query, OrdersV2ForReorderV2QueryVariables>({
    query: OrdersV2ForReorderV2Document,
    ...options,
  });
}
